export default (that) => [
  {
    field: 'seq',
    width: 50,
    fixed: 'left',
    align: 'center',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 85,
    slots: { default: 'opt' },
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_group_spec_name') ||
      '规格名称',
    field: 'groupSpecName',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_fabric_position_name') ||
      '面料位置',
    field: 'fabricPositionName',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_fabric_no') || '面料编号',
    field: 'fabricNo',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_fabric_name') || '面料名称',
    field: 'fabricDisplayName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 300,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_fabric_weight') || '面料克重',
    field: 'fabricWeight',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_is_specify') ||
      '客户指定供应商',
    field: 'isSpecify',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'isSpecify' },
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_scm_name') || '供应商名称',
    field: 'scmName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 280,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_is_customer_provide') ||
      '是否客供',
    field: 'isCustomerProvide',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'isCustomerProvide' },
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人姓名',
    field: 'modifyByName',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyTime',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
